import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import CloseIcon from '@mui/icons-material/Close';

import { FilterSelectIconButton } from './FilterDropdown/FilterDropdown.styles';

const FilterSelectIcon = ({ selected, filterKey, onClear, ...props }) =>
  selected.length > 0 ? (
    <FilterSelectIconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onClear(filterKey);
      }}
    >
      <CloseIcon fontSize="small" />
    </FilterSelectIconButton>
  ) : (
    <KeyboardArrowDownRoundedIcon {...props} />
  );

export default FilterSelectIcon;
